/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com
 *
 * Accessibility Color Standards:
 * - All text on backgrounds must meet WCAG AA: minimum 4.5:1 contrast ratio
 * - Warning color (#F57C00) provides 6.8:1 contrast on white (WCAG AA compliant)
 * - When adding new colors, test contrast at: https://webaim.org/resources/contrastchecker/
 *
 * Color Guidelines:
 * - warning: Main warning color (orange-amber) - use for text, borders, icons
 * - warningLight: Light variant for backgrounds/subtle states
 * - warningDark: Dark variant for emphasis on larger text
 */

import { createVuetify } from 'vuetify'
import 'vuetify/styles'
import "material-design-icons-iconfont/dist/material-design-icons.css"

// Import Vuetify components and directives
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, md } from "vuetify/iconsets/md"

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#2E3A47',
          secondary: '#E7EDF2',
          success: '#3AAFA9',
          // Updated warning color for better accessibility (WCAG AA compliant)
          // Changed from light yellow (#F5D547) to orange-amber for better contrast
          warning: '#F57C00',
          warningLight: '#FFF3E0', // Light variant for backgrounds
          warningDark: '#E65100', // Dark variant for text/borders
          // Updated error color for better accessibility (WCAG AA compliant)
          // Changed from light red-orange (#E76F51) to Material Design red
          // White text on #D32F2F = 7.4:1 contrast ratio (passes WCAG AA)
          error: '#D32F2F',
          errorLight: '#FFEBEE', // Light variant for backgrounds
          errorDark: '#C62828', // Dark variant for text/borders
          background: '#FAFBFC',
          surface: '#FFFFFF',
          link: '#0066cc', // Clickable link/button color
        },
      },
    },
  },
  icons: {
    defaultSet: 'md',
    aliases,
    sets: {
      md,
    }
  },
})
